<template>
  <div class="mainCnt">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="学校" disabled>
        <el-select v-model="value" clearable placeholder="请选择" size="mini">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="校区">
        <el-select v-model="campusID" clearable placeholder="请选择" size="mini" :loading="loading" @change="changeCampus">
          <el-option v-for="item in campusList" :key="item.CampusID" :label="item.CampusName" :value="item.CampusID"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="教学楼">
        <el-select v-model="teachingBuildingID" clearable placeholder="请选择" size="mini" :loading="loading">
          <el-option v-for="item in teachingBuildingList" :key="item.TeachingBuildingID" :label="item.TeachingBuildingName" :value="item.TeachingBuildingID"></el-option>
          <el-pagination @current-change="changeTeachingBuildingPage" :current-page.sync="teachingBuildingCurrentPage" :page-size="5" layout="total, prev, pager, next" :total="teachingBuildingTotalCount">
          </el-pagination>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="searchBox">
      <el-dropdown @command="changeSearchKey">
        <span class="el-dropdown-link" style="cursor: pointer">
          <i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in dropdownList" :key="index" :command="index">{{item}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="searchKey" v-show="searchKeyTxt">{{searchKeyTxt}}:</span>
      <!--设备类型-->
      <el-select v-model="deviceCategory" placeholder="请选择" size="mini" :style="searchKeyTxt?'width:390px;':'width:460px'" v-if="searchKeyIndex==0" @change="changeDeviceCategory">
        <el-option v-for="(item, index) in deviceCategoryList" :key="index" :label="item.Category" :value="index"></el-option>
      </el-select>
      <!--设备类别-->
      <el-select v-model="deviceType" placeholder="请选择" size="mini" style="width:390px;" v-else-if="searchKeyIndex==1">
        <el-option v-for="(item, index) in deviceTypeList" :key="index" :label="item.Name" :value="item.ID"></el-option>
      </el-select>
      <!--设备名称-->
      <el-input v-model="DeviceName" placeholder="请输入设备名称" size="mini" style="width:400px;" v-else-if="searchKeyIndex==2"></el-input>
      <!--教室名称-->
      <el-input v-model="ClassroomName" placeholder="请输入教室名称" size="mini" style="width:400px;" v-else-if="searchKeyIndex==3"></el-input>
      <!--唯一标识-->
      <el-input v-model="DeviceGuid" placeholder="请输入唯一标识" size="mini" style="width:400px;" v-else-if="searchKeyIndex==4"></el-input>
      <!--设备状态-->
      <el-select v-model="DeviceStatus" placeholder="请选择" size="mini" style="width:390px;" v-else-if="searchKeyIndex==5">
        <el-option v-for="(item, index) in deviceStatusList" :key="index" :label="item.name" :value="item.status"></el-option>
      </el-select>
      <!--局域网IP-->
      <el-input v-model="LanIpAddress" placeholder="请输入局域网IP地址" size="mini" style="width:400px;" v-else-if="searchKeyIndex==6"></el-input>
      <!--广域网IP-->
      <el-input v-model="WanIpAddress" placeholder="请输入广域网IP地址" size="mini" style="width:400px;" v-else-if="searchKeyIndex==7"></el-input>
      <!--硬盘使用率-->
      <el-input v-model="HDUsed" placeholder="例如：>=80" size="mini" style="width:400px;" v-else-if="searchKeyIndex==8"></el-input>
      <!--CPU使用率-->
      <el-input v-model="CPUUsed" placeholder="例如：>=80" size="mini" style="width:400px;" v-else-if="searchKeyIndex==9"></el-input>
      <!--内存使用率-->
      <el-input v-model="RAMUsed" placeholder="例如：>=80" size="mini" style="width:400px;" v-else-if="searchKeyIndex==10"></el-input>
      <!--授权日期-->
      <el-select v-model="ToBeExpireDays" placeholder="请选择" size="mini" style="width:390px;" v-else>
        <el-option v-for="(item, index) in expireList" :key="index" :label="item.name" :value="item.day"></el-option>
      </el-select>
      <span class="searchIcon" @click="addSearchCondition">
        <i class="el-icon-search"></i>
      </span>
    </div>
    <div style="padding:10px 0px;">
      <el-tag size="mini" :key="index" v-for="(tag, index) in dynamicTags" closable :disable-transitions="false" @close="delSearchCondition(index)" style="margin-right:5px;">{{tag.txt}}</el-tag>
    </div>
    <!--表格数据-->
    <div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" border stripe>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="deviceTypeName" label="设备类型" width="180"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" width="150"></el-table-column>
        <el-table-column prop="classroomName" label="教室名称" width="150"></el-table-column>
        <el-table-column prop="deviceGuid" label="唯一标识" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.deviceStatus== 0"><i class="el-icon-error danger" style="margin-right:5px;"></i>离线</span>
            <span v-else><i class="el-icon-success success" style="margin-right:5px;"></i>运行中</span>
          </template>
        </el-table-column>
        <el-table-column prop="lastOffLineTime" label="离线时间" width="165"></el-table-column>
        <el-table-column label="IP地址" width="140">
          <template slot-scope="scope">
            <p v-show="scope.row.lanIpAddress">{{scope.row.lanIpAddress}}(内)</p>
            <p v-show="scope.row.wanIpAddress">{{scope.row.wanIpAddress}}(外)</p>
          </template>
        </el-table-column>
        <el-table-column prop="expireTime" label="到期时间" width="100"></el-table-column>
        <el-table-column label="操作" fixed="right" width="200px">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" icon="el-icon-edit" @click="editDevice(scope.row)">编辑</el-link>
            <el-link type="primary" :underline="false" icon="el-icon-notebook-2" @click="openDetail(scope.row)">详情</el-link>
            <el-link type="primary" :underline="false" icon="el-icon-upload">升级</el-link>
            <el-upload
              :action="$store.state.host + '/api/2019/iot/InvokeDeviceAction'"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
              :before-upload="beforeUpload"
              :name="'File'"
              :headers="{AccessToken:'ceshi1'}"
              :data="{'DeviceGuid':scope.row.deviceGuid,'ActionCommand':0,NeedResponse:true}"
            >
              <el-link type="primary" :underline="false" icon="el-icon-check">授权</el-link>
            </el-upload>
            <el-link type="danger" :underline="false" icon="el-icon-delete" @click="deleteDevice(scope.row.id)">删除</el-link>
            <el-link type="primary" :underline="false" icon="el-icon-edit" :disabled="!scope.row.lanIpAddress" target="_blank" :href="'http://'+scope.row.lanIpAddress+':80/index1.html?username='+(scope.row.accountNo||'')+'&password=' + (scope.row.password ||'')">远程连接</el-link>
            <el-link type="primary" :underline="false" icon="el-icon-more">更多控制</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-checkbox class="fl" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <el-pagination style="margin-top:20px" class="fr" background @current-change="changeDeviceListPage" :current-page.sync="tableDataCurrentPage" :page-size="10" layout="total, prev, pager, next" :total="tableDataTotalCount">
      </el-pagination>
    </div>
    <!--详情信息-->
    <el-drawer title="详情信息" :visible.sync="drawer" :direction="'rtl'">
      <el-row v-if="deviceRowInfo" class="deviceDetail">
        <el-col :span="7" class="textRight">设备类型：</el-col>
        <el-col :span="17">{{deviceRowInfo.deviceTypeName}}</el-col>
      </el-row>
      <el-row v-if="deviceRowInfo" class="deviceDetail">
        <el-col :span="7" class="textRight">设备名称：</el-col>
        <el-col :span="17">{{deviceRowInfo.deviceName}}</el-col>
      </el-row>
      <el-row v-if="deviceRowInfo" class="deviceDetail">
        <el-col :span="7" class="textRight">局域网IP：</el-col>
        <el-col :span="17">{{deviceRowInfo.lanIpAddress || '无'}}</el-col>
      </el-row>
      <el-row v-if="deviceRowInfo" class="deviceDetail">
        <el-col :span="7" class="textRight">广域网IP：</el-col>
        <el-col :span="17">{{deviceRowInfo.wanIpAddress || '无'}}</el-col>
      </el-row>
      <el-row v-if="deviceRowInfo" class="deviceDetail">
        <el-col :span="7" class="textRight">唯一标识：</el-col>
        <el-col :span="17">{{deviceRowInfo.deviceGuid || '无'}}</el-col>
      </el-row>
      <el-row v-if="deviceRowInfo" class="deviceDetail">
        <el-col :span="7" class="textRight">参数：</el-col>
        <el-col :span="17" v-if="deviceRowInfo.parameters">
          <p v-for="(item, index) in deviceRowInfo.parameters" :key="index">{{item.name}}</p>
        </el-col>
        <el-col :span="17" v-else>无</el-col>
      </el-row>
      <el-row v-if="deviceRowInfo" class="deviceDetail">
        <el-col :span="7" class="textRight">事件：</el-col>
        <el-col :span="17" v-if="deviceRowInfo.events">
          <div style="padding-bottom:10px" v-for="(item, index) in deviceRowInfo.events" :key="index">
            <h4>{{item.Event}}</h4>
            <p v-for="(subItem, subIndex) in item.EventParams" :key="subIndex">
              {{subItem.paramName}}：{{subItem.paramValue}}
            </p>
          </div>
        </el-col>
        <el-col :span="17" v-else>无</el-col>
      </el-row>
    </el-drawer>
    <!--编辑弹窗-->
    <el-dialog title="编辑设备" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" label-width="150px">
        <el-form-item label="教室名称" v-if="form.classroomName">
          <el-select v-model="form.classroomName" placeholder="请选择" size="mini" :loading="loading" filterable remote :remote-method="remoteMethod" @change="classroomChagnge" value-key="ClassRoomID">
            <el-option v-for="item in classroomList" :key="item.ClassRoomID" :label="item.ClassRoomName" :value="item"></el-option>
            <el-pagination @current-change="changeClassroomPage" :current-page.sync="classroomCurrentPage" :page-size="5" layout="total, prev, pager, next" :total="classroomTotalCount">
            </el-pagination>
          </el-select>
          <!--<el-input v-model="form.deviceName" placeholder="请输入内容" :size="mini"></el-input>-->
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="form.deviceName" placeholder="请输入内容" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select v-model="form.deviceCategory" placeholder="请选择" size="mini" @change="changeDeviceCategoryEdit">
            <el-option v-for="(item, index) in deviceCategoryList" :key="index" :label="item.Category" :value="item.Category"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类别">
          <el-select v-model="form.deviceType" placeholder="请选择" size="mini">
            <el-option v-for="(item, index) in deviceTypeListEdit" :key="index" :label="item.Name" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="局域网IP">
          <el-input v-model="form.lanIpAddress" placeholder="请输入内容" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="远程账号">
          <el-input v-model="form.accountNo" placeholder="请输入内容" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="远程密码">
          <el-input v-model="form.password" placeholder="请输入内容" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible=false">取 消</el-button>
        <el-button type="primary" size="mini" @click="editDeviceSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Details',
  data () {
    return {
      schoolID: '',
      loading: false,
      campusList: [], // 校区
      campusID: '',
      teachingBuildingList: [], // 教学楼
      teachingBuildingCondition: '',
      teachingBuildingTotalCount: 0,
      teachingBuildingCurrentPage: 1,
      teachingBuildingID: '',
      dropdownList: ['设备类别', '设备类型', '设备名称', '教室名称', '唯一标识', '设备状态', '局域网IP', '广域网IP', '硬盘使用率', 'CPU使用率', '内存使用率', '授权日期'],
      dynamicTags: [],
      expireList: [
        {name: '即将过期', day: 7},
        {name: '已过期', day: 0}
      ],
      deviceStatusList: [
        {name: '离线', status: 0},
        {name: '运行中', status: 1}
      ],
      deviceTypeAll: [],
      deviceTypeList: [],
      deviceTypeListEdit: [],
      deviceCategoryList: [],
      deviceCategory: '',
      deviceType: '',
      ToBeExpireDays: '',
      DeviceStatus: '',
      LanIpAddress: '',
      WanIpAddress: '',
      HDUsed: '',
      CPUUsed: '',
      RAMUsed: '',
      DeviceGuid: '',
      ClassroomName: '',
      DeviceName: '',
      searchKeyTxt: '',
      searchKeyIndex: 0,
      multipleSelection: [],
      tableData: [],
      tableDataTotalCount: 0,
      tableDataCurrentPage: 1,
      isIndeterminate: false,
      checkAll: false,
      condition: { // 搜索条件
        deviceTypes: [],
        deviceName: '',
        classroomName: '',
        deviceGuid: '',
        deviceStatus: '',
        lanIpAddress: '',
        wanIpAddress: '',
        hdUsed: '',
        cpuUsed: '',
        ramUsed: '',
        expireTime: '',
        toBeExpireDays: ''
      }, // 表格查询的条件
      drawer: false,
      deviceRowInfo: null,
      form: {
        id: '',
        classroomID: '',
        classroomName: '',
        deviceName: '',
        deviceCategory: '',
        deviceType: '',
        lanIpAddress: '',
        wanIpAddress: '',
        accountNo: '',
        password: '',
        port: '',
        parameters: []
      },
      dialogVisible: false,
      classroomList: [], // 教室
      classroomCurrentPage: 1,
      classroomTotalCount: 0,
      classroomCondition: '',
      input: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }],
      value: ''
    }
  },
  watch: {
    '$store.state.schoolID': function (val) { // 刷新当前页面
      this.initData()
    },
    '$store.state.deviceCategory': function (val) {
      if (this.deviceCategoryList.length > 0) {
        this.leftMenuChangeDeviceCategory()
      }
    }
  },
  mounted () {
    if (this.$store.state.schoolID) {
      this.initData()
    }
  },
  methods: {
    initData () {
      this.schoolID = this.$store.state.schoolID
      this.getCampusList()
      this.getTeachingBuildingList(this.teachingBuildingCurrentPage)
      this.getDeviceType()
    },
    // 左侧菜单点击切换设备类别
    leftMenuChangeDeviceCategory () {
      if (parseInt(this.$store.state.deviceCategory) === 0) {
        this.condition.deviceTypes = []
        this.deviceTypeList = this.deviceTypeAll
        this.dynamicTags = []
        this.getDeviceList()
      } else {
        this.deviceCategory = this.$store.state.deviceCategory - 1
        this.searchKeyIndex = 0
        this.searchKeyTxt = '设备类别'
        this.changeDeviceCategory(this.deviceCategory)
        this.addSearchCondition()
      }
    },
    // 获取设备类型
    getDeviceType () {
      this.$http.post('/Device/GetDeviceType', {}).then(res => {
        if (res.body.Success) {
          this.deviceTypeAll = res.body.Value
          this.deviceTypeList = res.body.Value
          let lastName = '' // 数据类型名称
          this.deviceCategoryList = []
          res.body.Value.map(val => {
            if (val.Category !== lastName) {
              lastName = val.Category
              this.deviceCategoryList.push(val)
            }
          })
          this.leftMenuChangeDeviceCategory()
        }
      })
    },
    changeDeviceCategory (index) {
      this.deviceTypeList = []
      this.deviceTypeAll.map(val => {
        if (this.deviceCategoryList[index].Category === val.Category) {
          this.deviceTypeList.push(val)
        }
      })
    },
    changeDeviceCategoryEdit (category) {
      this.deviceTypeListEdit = []
      this.deviceTypeAll.map(val => {
        if (category === val.Category) {
          this.deviceTypeListEdit.push(val)
        }
      })
      this.form.deviceType = ''
    },
    // 获取校区
    getCampusList () {
      this.loading = true
      this.$http.post('/Campus/Select', {SchoolID: this.schoolID}, {emulateJSON: true}).then(function (res) {
        this.loading = false
        if (res.body.Success) {
          this.campusList = res.body.Value.Data
        }
      })
    },
    changeCampus (val) {
      this.teachingBuildingCurrentPage = 1
      this.getTeachingBuildingList(this.teachingBuildingCurrentPage)
    },
    // 获取教学楼
    getTeachingBuildingList (PageNumber) {
      this.loading = true
      this.$http.post('/TeachingBuilding/Select', {
        SchoolID: this.schoolID,
        CampusID: this.campusID,
        QueryCondition: this.teachingBuildingCondition,
        PageNumber: PageNumber,
        PageSize: 5
      }, {emulateJSON: true}).then(res => {
        this.loading = false
        if (res.body.Success) {
          this.teachingBuildingList = res.body.Value.Data
          this.teachingBuildingTotalCount = res.body.Value.TotalCount
        }
      })
    },
    changeTeachingBuildingPage (val) {
      this.getTeachingBuildingList(val)
    },
    // 获取教室列表
    getClassroom () {
      this.$http.post('/ClassRoom/Select', {SchoolID: this.schoolID, QueryCondition: this.classroomCondition, keyword: this.classroomCondition, PageSize: 5, PageNumber: this.classroomCurrentPage, page: 1, rows: 10}, {emulateJSON: true}).then(res => {
        if (res.body.Success) {
          this.classroomList = res.body.Value.Data
          this.classroomTotalCount = res.body.Value.TotalCount
        }
      })
    },
    changeClassroomPage (page) {
      this.getClassroom()
    },
    remoteMethod (condition) {
      this.classroomCondition = condition
      this.classroomCurrentPage = 1
      this.getClassroom()
    },
    classroomChagnge (val) {
      if (this.form.classroomName) {
        this.form.classroomID = val.ClassRoomID
      }
    },
    // 改变搜索关键字
    changeSearchKey (command) {
      this.searchKeyIndex = command
      this.searchKeyTxt = this.dropdownList[command]
    },
    // 添加搜索关键字
    addSearchCondition () {
      if (this.searchKeyTxt) {
        // 将原来的搜索条件删除
        let index = this.dynamicTags.findIndex((item, index) => item.searchKeyIndex === this.searchKeyIndex)
        if (index !== -1) {
          this.dynamicTags.splice(index, 1)
        }
        if (this.searchKeyIndex === 0) { // 设备类别
          // 将设备类别也删除
          let index = this.dynamicTags.findIndex((item, index) => item.searchKeyIndex === 1)
          if (index !== -1) { this.dynamicTags.splice(index, 1) }
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.deviceCategoryList[this.deviceCategory].Category, searchKeyIndex: this.searchKeyIndex})
          this.condition.deviceTypes = []
          this.deviceTypeList.map(val => {
            this.condition.deviceTypes.push(val.ID)
          })
        } else if (this.searchKeyIndex === 1) { // 设备类型
          let obj = this.deviceTypeList.find(val => val.ID === this.deviceType)
          let txt = ''
          if (obj) { txt = obj.Name }
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + txt, searchKeyIndex: this.searchKeyIndex})
          this.condition.deviceTypes = [this.deviceType]
        } else if (this.searchKeyIndex === 2) { // 设备名称
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.DeviceName, searchKeyIndex: this.searchKeyIndex})
          this.condition.deviceName = this.deviceName
        } else if (this.searchKeyIndex === 3) { // 教室名称
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.ClassroomName, searchKeyIndex: this.searchKeyIndex})
          this.condition.classroomName = this.ClassroomName
        } else if (this.searchKeyIndex === 4) { // 唯一标识
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.DeviceGuid, searchKeyIndex: this.searchKeyIndex})
          this.condition.deviceGuid = this.DeviceGuid
        } else if (this.searchKeyIndex === 5) { // 设备状态
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.deviceStatusList[this.DeviceStatus].name, searchKeyIndex: this.searchKeyIndex})
          this.condition.deviceStatus = this.DeviceStatus
        } else if (this.searchKeyIndex === 6) { // 局域网
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.LanIpAddress, searchKeyIndex: this.searchKeyIndex})
          this.condition.lanIpAddress = this.LanIpAddress
        } else if (this.searchKeyIndex === 7) { // 广域网
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.WanIpAddress, searchKeyIndex: this.searchKeyIndex})
          this.condition.wanIpAddress = this.WanIpAddress
        } else if (this.searchKeyIndex === 8) { // 硬盘使用率
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.HDUsed, searchKeyIndex: this.searchKeyIndex})
          this.condition.hdUsed = this.HDUsed
        } else if (this.searchKeyIndex === 9) { // cpu
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.CPUUsed, searchKeyIndex: this.searchKeyIndex})
          this.condition.cpuUsed = this.CPUUsed
        } else if (this.searchKeyIndex === 10) { // ram
          this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.RAMUsed, searchKeyIndex: this.searchKeyIndex})
          this.condition.ramUsed = this.RAMUsed
        } else if (this.searchKeyIndex === 11) { // 授权日期
          if (this.ToBeExpireDays === 7) {
            this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.expireList[0].name, searchKeyIndex: this.searchKeyIndex})
            this.condition.expireTime = ''
            this.condition.toBeExpireDays = this.ToBeExpireDays
          } else {
            this.dynamicTags.push({txt: this.searchKeyTxt + '：' + this.expireList[1].name, searchKeyIndex: this.searchKeyIndex})
            this.condition.toBeExpireDays = ''
            this.condition.expireTime = this.getNowDate()
          }
        }
        this.getDeviceList()
      }
    },
    // 删除搜索关键字
    delSearchCondition (index) {
      this.dynamicTags.splice(index, 1)
      if (index === 0) {
        let obj = this.dynamicTags.find(val => val.searchKeyIndex === 1)
        if (obj) {
          this.condition.deviceTypes = [this.deviceType]
        } else {
          this.condition.deviceTypes = []
        }
      } else if (index === 1) {
        let obj = this.dynamicTags.find(val => val.searchKeyIndex === 0)
        if (obj) {
          this.changeDeviceCategory(this.deviceCategory)
          this.condition.deviceTypes = []
          this.deviceTypeList.map(val => {
            this.condition.deviceTypes.push(val.ID)
          })
        }
      } else if (index === 2) { // 设备名称
        this.condition.deviceName = ''
      } else if (index === 3) { // 教室名称
        this.condition.classroomName = ''
      } else if (index === 4) { // 唯一标识
        this.condition.deviceGuid = ''
      } else if (index === 5) { // 设备状态
        this.condition.deviceStatus = ''
      } else if (index === 6) { // 局域网
        this.condition.lanIpAddress = ''
      } else if (index === 7) { // 广域网
        this.condition.wanIpAddress = ''
      } else if (index === 8) { // 硬盘使用率
        this.condition.hdUsed = ''
      } else if (index === 9) { // cpu
        this.condition.cpuUsed = ''
      } else if (index === 10) { // ram
        this.ramUsed = ''
      } else if (index === 11) { // 授权日期
        this.condition.expireTime = ''
        this.condition.toBeExpireDays = ''
      }
      this.getDeviceList()
    },
    // 获取当前时间
    getNowDate () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let seconds = date.getSeconds()
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    },
    // 显示提示框
    showToolTip (params) {
      if (params.type === 'error') {
        this.$message.error(params.message)
      } else {
        this.$message({
          type: params.type,
          message: params.message
        })
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (this.multipleSelection.length === this.tableData.length) {
        this.checkAll = true
        this.isIndeterminate = false
      } else if (this.multipleSelection.length > 0) {
        this.isIndeterminate = true
      } else {
        this.checkAll = false
        this.isIndeterminate = false
      }
    },
    getDeviceList () {
      this.$http.post(this.$store.state.host + '/api/2019/iot/SearchDevice', {
        PageSize: 10,
        PageNumber: this.tableDataCurrentPage,
        SchoolID: this.schoolID,
        CampusID: this.campusID,
        TeachingBuildingID: this.teachingBuildingID,
        DeviceTypes: this.condition.deviceTypes,
        DeviceName: this.condition.deviceName,
        ClassroomName: this.condition.classroomName,
        DeviceGuid: this.condition.deviceGuid,
        DeviceStatus: this.condition.deviceStatus,
        LanIpAddress: this.condition.lanIpAddress,
        WanIpAddress: this.condition.wanIpAddress,
        HDUsed: this.condition.hdUsed,
        CPUUsed: this.condition.cpuUsed,
        RAMUsed: this.condition.ramUsed,
        ExpireTime: this.condition.expireTime,
        ToBeExpireDays: this.condition.toBeExpireDays
      }).then(res => {
        if (res.body.code === 200) {
          // this.tableData = res.body.data.data
          this.tableData = []
          res.body.data.data.map(val => {
            val.expireTime = val.expireTime ? val.expireTime.split(' ')[0] : ''
            for (let i = 0; i < this.deviceTypeAll.length; i++) {
              if (val.deviceType === this.deviceTypeAll[i].ID) {
                val.deviceTypeName = this.deviceTypeAll[i].Name
                this.tableData.push(val)
                break
              }
            }
          })
          this.tableDataTotalCount = res.body.data.totalElements
        }
      })
    },
    changeDeviceListPage (page) {
      this.getDeviceList()
    },
    handleCheckAllChange (val) {
      this.isIndeterminate = false
      if (val) {
        this.$refs.multipleTable.toggleAllSelection()
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 打开详情
    openDetail (row) {
      console.log(row)
      this.deviceRowInfo = row
      this.drawer = true
    },
    // 删除设备
    deleteDevice (id) {
      let that = this
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$http.post(that.$store.state.host + '/api/2019/Device/Del', {ids: id}).then(res => {
          if (res.body.code === 200) {
            that.$message({
              type: 'success',
              message: '删除成功'
            })
            that.getDeviceList()
          } else {
            that.$message.error(res.body.msg)
          }
        })
      })
    },
    editDevice (row) {
      this.dialogVisible = true
      this.getClassroom()
      this.form.classroomName = row.classroomName
      this.form.deviceName = row.deviceName
      this.form.lanIpAddress = row.lanIpAddress
      this.form.wanIpAddress = row.wanIpAddress
      this.form.accountNo = row.accountNo
      this.form.password = row.password
      this.form.port = row.password
      this.form.parameters = row.parameters
      this.form.id = row.id
      for (let i = 0; i < this.deviceTypeAll.length; i++) {
        if (row.deviceType === this.deviceTypeAll[i].ID) {
          this.form.deviceCategory = this.deviceTypeAll[i].Category
          this.form.deviceType = row.deviceType
          break
        }
      }
      this.deviceTypeListEdit = []
      for (let i = 0; i < this.deviceTypeAll.length; i++) {
        if (this.form.deviceCategory === this.deviceTypeAll[i].Category) {
          this.deviceTypeListEdit.push(this.deviceTypeAll[i])
        }
      }
    },
    editDeviceSave () {
      this.$http.post(this.$store.state.host + '/api/2019/Device/Update', {
        id: this.form.id,
        ClassroomID: this.form.classroomID,
        DeviceType: this.form.deviceType,
        DeviceName: this.form.deviceName,
        WanIpAddress: this.form.wanIpAddress,
        LanIpAddress: this.form.lanIpAddress,
        Port: this.form.port,
        AccountNo: this.form.accountNo,
        Password: this.form.password,
        Parameters: this.form.parameters
      }).then(res => {
        if (res.body.code === 200) {
          this.$message({
            type: 'success',
            message: '编辑成功'
          })
        } else {
          this.$message.error(res.body.msg)
        }
      })
    },
    // 授权上传之前
    beforeUpload (file) {
      if (file.name.split('.')[1].toUpperCase() !== 'LIC') {
        this.$message({
          showClose: true,
          message: '请上传后缀名为LIC格式的文件',
          type: 'danger'
        })
        return false
      }
    },
    // 上传成功之后
    handleUploadSuccess (res, file) {
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: res.data
        })
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'danger'
        })
      }
    }
  }
}
</script>
<style>
  .mainCnt .searchBox .el-input__inner{
    border:none;
    padding:0px 0px;
  }
</style>
<style scoped>
  .mainCnt{
    margin: 15px;
    padding: 20px;
    background: #fff;
    webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.08);
    -webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.08);
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.08);
  }
  .mainCnt .searchBox{
    position: relative;
    display: inline-block;
    padding-left:5px;
    border: 1px solid #DCDFE6;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    overflow: hidden;
    width:540px;
  }
  .mainCnt .searchIcon{
    background:#f5f7fa;
    color:#909399;
    width:60px;
    display: inline-block;
    text-align: center;
    line-height:28px;
    position:absolute;
    top:0px;
    right:0px;
  }
  .searchKey{
    display: inline-block;
    font-size:12px;
    width:70px;
    color:#606266;
  }
  .deviceDetail{
    font-size:14px;
    color:#333;
    margin-bottom:15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Details.vue